import { Video } from '@/model';
import {
  GetMediaVideoByIdResponse,
  GetMediaVideoItemResponse,
  GetMediaVideoResponse,
  PostMediaVideoResponse,
  PutMediaVideoResponse,
} from '@/services/response/video';

export class VideoConverter {
  static toDomainFromGetItemResponse(response: GetMediaVideoItemResponse): Video {
    return {
      uuid: response.uuid,
      category_video_uuid: response.category_video_uuid,
      category_video_name: response.category_video_name,
      video_id: response.video_id,
      video_url: response.video_url,
      title: response.title,
      image_thumbnail: response.image_thumbnail,
      status: response.status,
      order: response.order,
      business_unit_uuid: response.business_unit_uuid,
      team_uuid: response?.team_uuid,
      team_name: response?.team_name,
      team_image: response?.team_image,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }

  static toDomainFromPaginatedResponse(response: GetMediaVideoResponse): Video[] {
    return response.data.map(VideoConverter.toDomainFromGetItemResponse);
  }

  static toDomainFromPostResponse(response: PostMediaVideoResponse): Video {
    return {
      uuid: response.uuid,
      category_video_uuid: response.category_video_uuid,
      category_video_name: response.category_video_name,
      video_id: response.video_id,
      video_url: response.video_url,
      title: response.title,
      image_thumbnail: response.image_thumbnail,
      status: response.status,
      order: response.order,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }

  static toDomainFromByIdResponse(response: GetMediaVideoByIdResponse): Video {
    return {
      uuid: response.uuid,
      category_video_uuid: response.category_video_uuid,
      category_video_name: response.category_video_name,
      team_uuid: response?.team_uuid,
      team_name: response?.team_name,
      team_image: response?.team_image,
      video_id: response.video_id,
      video_url: response.video_url,
      title: response.title,
      image_thumbnail: response.image_thumbnail,
      status: response.status,
      order: response.order,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }

  static toDomainFromPutResponse(response: PutMediaVideoResponse): Video {
    return {
      uuid: response.uuid,
      category_video_uuid: response.category_video_uuid,
      category_video_name: response.category_video_name,
      video_id: response.video_id,
      video_url: response.video_url,
      title: response.title,
      image_thumbnail: response.image_thumbnail,
      status: response.status,
      order: response.order,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }
}
